import { render, staticRenderFns } from "./delete-realestate.vue?vue&type=template&id=22cb4339&"
import script from "./delete-realestate.vue?vue&type=script&lang=js&"
export * from "./delete-realestate.vue?vue&type=script&lang=js&"
import style0 from "./delete-realestate.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/anatec/wesave/wesave-conseil-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('22cb4339', component.options)
    } else {
      api.reload('22cb4339', component.options)
    }
    module.hot.accept("./delete-realestate.vue?vue&type=template&id=22cb4339&", function () {
      api.rerender('22cb4339', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/toasts/delete-realestate.vue"
export default component.exports